<!-- Your app's shell. THIS FILE IS YOURS — the factory never replaces it.
     Everything imported from ./core is maintained by `appfactory upgrade`.

     This file is now DELIBERATELY THIN. It is the root: an IonApp, the outlet
     the router paints into, and the handful of things that must exist on every
     screen at once — the demo banner, onboarding, toasts, live regions.

     The screens themselves live in src/pages/, wired up in src/router.js, and
     the state they share is src/store.js. That split is the whole reason the
     chassis moved to Ionic's router: pages that mount and unmount get real
     push/pop transitions and a per-tab back stack, which a single component
     switching on a `current` string cannot have.

     WHERE TO START:
       src/router.js      your tabs, and what each one opens
       src/pages/         one file per screen — replace the worked example
       src/store.js       the data those screens read and write
       src/styles/app.css your own CSS, loaded last and never overwritten

     The worked example runs as-is. REPLACE THE CONTENT AND KEEP THE DENSITY:
     whatever is in pages/ is what the next app looks like. -->
<template>
  <IonApp>
    <!-- Says, permanently, that this is not your data.
         Outside the router outlet on purpose, so it shows on every screen
         rather than only the one that happened to render it. The chassis used
         to put this inside its own AppShell — the Ionic port dropped that
         component, the banner silently stopped rendering, and the demo no
         longer said it was a demo. That is the one thing core/demo.js insists
         on: sample data that looks like your own is a support ticket. -->
    <DemoBanner v-if="isDemo" />

    <IonRouterOutlet />

    <!-- Three or four cards, purpose and how-to-use. Shown once, ever.
         Give it an empty array and nothing renders at all. -->
    <Onboarding :cards="onboarding" />

    <!-- Toasts, the undo bar, and the screen-reader live regions.
         Mounted once, here. Nothing imports it to use it. -->
    <Overlays />
  </IonApp>
</template>

<script setup>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { APP_NAME, APP_TAGLINE } from '../app-config.js';
import { Onboarding, DemoBanner, Overlays, isDemo } from './core/ui';

const onboarding = [
  { title: `Welcome to ${APP_NAME}`, body: APP_TAGLINE },
  { title: 'Everything works offline', body: 'Open it with no signal and it still runs. Changes sync when you are back.' },
  { title: 'It updates itself', body: 'New versions arrive quietly. You will be asked before anything reloads.' },
];
</script>

